const PagePresets = {
  PageView: {
    attrs: {
      showDislikeButton: true
    }
  }
};
export {
  PagePresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFnZVByZXNldHMuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvY29tcG9uZW50cy9QYWdlUHJlc2V0cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIFBhZ2VWaWV3OiB7XG4gICAgYXR0cnM6IHtcbiAgICAgIHNob3dEaXNsaWtlQnV0dG9uOiB0cnVlLFxuICAgIH0sXG4gIH0sXG59O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQWUsY0FBQTtBQUFBLEVBQ2IsVUFBVTtBQUFBLElBQ1IsT0FBTztBQUFBLE1BQ0wsbUJBQW1CO0FBQUEsSUFDcEI7QUFBQSxFQUNGO0FBQ0g7In0=
